import { get } from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@custom-components';

import MuiTableHead from '@mui/material/TableHead';
import MuiTableBody from '@mui/material/TableBody';
import MuiTableRow from '@mui/material/TableRow';

import { TableWrapper, StyledCell, StyledTable } from './SelectTable.styles';
import { ReactChildrenPropType } from '../../../lib/commonPropTypes';

class Table extends Component {
  constructor(props) {
    super(props);
    this.renderBody = this.renderBody.bind(this);
    this.renderHead = this.renderHead.bind(this);
  }

  renderHead() {
    const { rows, headerCellsConfig } = this.props;
    return (
      <MuiTableHead>
        <MuiTableRow>
          {rows &&
            rows.map((row) => {
              const { id, label } = row;
              const cellConfigProps = get(headerCellsConfig, `${id}`, {});
              return (
                <StyledCell key={id} {...cellConfigProps}>
                  <Text.CopyMini noMargins>{label}</Text.CopyMini>
                </StyledCell>
              );
            })}
        </MuiTableRow>
      </MuiTableHead>
    );
  }

  renderBody() {
    const { children, contentCellsConfig } = this.props;
    return children ? (
      <MuiTableBody>
        {children.map((child) => (
          <MuiTableRow key={child.id}>
            {Object.entries(child).map(([key, item]) => {
              if (key === 'id') return null;
              const cellConfigProps = get(contentCellsConfig, `${key}`, {});
              return (
                <StyledCell key={key} {...cellConfigProps}>
                  {item}
                </StyledCell>
              );
            })}
          </MuiTableRow>
        ))}
      </MuiTableBody>
    ) : undefined;
  }

  render() {
    const { minTableWidth, viewHeader } = this.props;
    return (
      <TableWrapper>
        <StyledTable minTableWidth={minTableWidth}>
          {viewHeader && this.renderHead()}
          {this.renderBody()}
        </StyledTable>
      </TableWrapper>
    );
  }
}

Table.propTypes = {
  /** Array of content objects to display in table */
  children: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, ReactChildrenPropType]))),
  /** Object with keys matching row object IDs containing @MUITableCell properties and valid td attributes */
  contentCellsConfig: PropTypes.shape({}),
  /** Object with keys matching row object IDs containing @MUITableCell properties and valid td attributes */
  headerCellsConfig: PropTypes.shape({}),
  /** Min width of the table passed via string (900px default) */
  minTableWidth: PropTypes.string,
  /** Array of label objects to display at the top of the table */
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      width: PropTypes.string
    })
  ).isRequired,
  viewHeader: PropTypes.bool
};

Table.defaultProps = {
  children: undefined,
  contentCellsConfig: {},
  headerCellsConfig: {},
  minTableWidth: '900px',
  viewHeader: true
};

export default Table;
